import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import type { RevealQuotaUsageResponse } from '@albacross/types'

import { get } from 'utils/http'

export const useCustomerRevealApiQuota = () => {
  const customerId = useCustomerId()
  return useQuery({
    queryKey: ['customer', customerId, 'reveal_api_quota'],
    queryFn: () =>
      get<Partial<RevealQuotaUsageResponse>>(`/management/customers/${customerId}/reveal_api/quota/usage`, {
        query: { live: true },
      }),
  })
}
